import { navigationMenuLinks } from './navigation-links.js';
import { getMenuLinkAttributes } from './get-menu-link-attributes.js';

export function headerSubmenu() {
    const header = document.querySelector('.header--js');
    if (!!header === false) return;
    const mainMenu = header.querySelector('.header-main-menu--js');
    if (!!mainMenu === false) return;
    const mainMenuNav = header.querySelector('.main-menu-nav--js');
    if (!!mainMenuNav === false) return;
    let openedSumbmenu = null;

    const buttons = header.querySelectorAll('button[data-header-submenu]');
    buttons.forEach((button) => {
        const submenuId = button.getAttribute('data-header-submenu');
        const submenu = navigationMenuLinks.find((submenu) => submenu.id === submenuId);
        if (submenu) {
            submenu.button = button;

            button.addEventListener('mouseenter', () => {
                handleSubmenuHover(submenu);
            });

            button.addEventListener('focus', () => {
                handleSubmenuHover(submenu);
            });

            button.addEventListener('keydown', (event) => {
                const key = event.key;
                if (key === 'Enter' || key === ' ' || key === 'ArrowDown') {
                    event.preventDefault();
                    handleSubmenuHover(submenu);
                    focusFirstSubmenuLink();
                } else if (key === 'Escape') {
                    closeHeaderSubmenu();
                    button.focus();
                }
            });
        }
    });

    header.addEventListener('mouseleave', () => {
        closeHeaderSubmenu();
    });

    header.addEventListener('focusout', (event) => {
        const nextFocused = event.relatedTarget;
        if (!nextFocused || !header.contains(nextFocused)) {
            closeHeaderSubmenu();
        }
    });

    window.addEventListener(
        'scroll',
        () => {
            closeHeaderSubmenu();
        },
        { passive: true }
    );

    function handleSubmenuHover(submenu) {
        openHeaderSubmenu(submenu);
    }

    function openHeaderSubmenu(submenu) {
        navigationMenuLinks.forEach((theSubmenu) => {
            theSubmenu.active = theSubmenu === submenu;
            theSubmenu.button.classList.toggle('active', theSubmenu.active);
        });
        mainMenuNav.innerHTML = getSubmenuNavHTMLString(submenu);
        if (openedSumbmenu === null) {
            mainMenu.classList.add('before-open');
            setTimeout(() => {
                mainMenu.classList.add('opened');
                mainMenu.classList.remove('before-open');
            });
        }
        openedSumbmenu = submenu;
    }

    function closeHeaderSubmenu() {
        if (openedSumbmenu === null) return;
        openedSumbmenu.active = false;
        openedSumbmenu.button.classList.remove('active');
        openedSumbmenu = null;
        mainMenu.classList.add('before-close');
        setTimeout(() => {
            mainMenu.classList.remove('opened');
            mainMenu.classList.remove('before-close');
        }, 300);
    }

    function focusFirstSubmenuLink() {
        const firstLink = mainMenuNav.querySelector('.main-menu-nav-link');
        if (firstLink) {
            firstLink.focus();
        }
    }

    function getSubmenuNavHTMLString(submenu) {
        let html = `<ul class="main-menu-nav-list">`;
        submenu.links.forEach((linkObj) => {
            html += `<li class="main-menu-nav-item">`;
            const primaryLinkAttrs = getMenuLinkAttributes(linkObj);
            html += `<a ${primaryLinkAttrs} class="main-menu-nav-link main-menu-nav-link--primary">${linkObj.text}</a>`;

            // Check if this item has nested links
            if (linkObj.links && linkObj.links.length > 0) {
                html += `<ul class="main-menu-nav-sublist">`;
                linkObj.links.forEach((subLinkObj) => {
                    html += `<li class="main-menu-nav-subitem">`;
                    const secondaryLinkAttrs = getMenuLinkAttributes(subLinkObj);
                    html += `<a ${secondaryLinkAttrs} class="main-menu-nav-link main-menu-nav-link--secondary">${subLinkObj.text}</a>`;
                    html += `</li>`;
                });
                html += `</ul>`;
            }

            html += `</li>`;
        });
        return (html += '</ul>');
    }
}
